import './App.css';
import { Header } from './components/Layout/Header';
import { AllRoutes } from './routes/AllRoutes';
import { Footer } from './components/Layout/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <AllRoutes />
      <Footer />
    </div>
  );
}

export default App;
